<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p style="margin-bottom: 5px;" class="cardTitleType1">{{ tajukKad }}</p>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <span style="margin-bottom: 4px; font-weight: 300;" v-if="buttonFull">Sila tekan butang <el-button type="secondary smaller">Fleet Card Dalam Proses</el-button> apabila Fleet Card pemohon mula diproses.</span>
          <span style="margin-bottom: 20px; font-weight: 300;" v-if="buttonFull">Sila tekan butang <el-button type="primary smaller">Hantar Fleet Card</el-button> apabila Fleet Card pemohon telah dihantar.</span>
          <template v-if="vehicleLoaded">
            <el-table
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="vehicleArray"
              v-loading.body="loading"
              element-loading-text="Loading"
              @sort-change="sortChange"
              fit
              highlight-current-row
            >
            <!-- @row-click="rowClick"
              row-class-name="rowClickable" -->
              <el-table-column
                label="No."
                width="50" type="index" :index="indexMethod">
              </el-table-column>
              <el-table-column
                prop="vehicleNumber"
                label="No. Pendaftaran Kenderaan"
                width="140"
                :sortable="false">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                    <span style="word-break: break-word;">{{ scope.row.vehicleNumber }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="vehiclebodytypeId"
                label="Sektor Pengangkutan"
                width="140"
                :sortable="false">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                    <span style="word-break: break-word;">{{ scope.row.vehiclebodytypeId && scope.row.vehiclebodytypeId.bodytypeSector ? scope.row.vehiclebodytypeId.bodytypeSector === 'awam' ? 'AWAM' : scope.row.vehiclebodytypeId.bodytypeSector === 'barangan' ? 'BARANGAN' : scope.row.vehiclebodytypeId.bodytypeSector : scope.row.vehicleBodyTypeSector ? scope.row.vehicleBodyTypeSector : '-' }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="vehiclebodytypeId"
                label="Jenis Badan"
                width="240"
                :sortable="false">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                    <!-- <span style="word-break: break-word;">{{ scope.row.vehiclebodytypeId ? `(${scope.row.vehiclebodytypeId.bodytypeCode}) - ${scope.row.vehiclebodytypeId.bodytypeName}` : '-' }}</span> -->
                    <span style="word-break: break-word;">{{ scope.row.vehicleBodyTypeName ? `${scope.row.vehicleBodyTypeCode ? `(${scope.row.vehicleBodyTypeCode}) - `  : ''}${scope.row.vehicleBodyTypeName}` : '-' }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="vehiclemodeltypeId"
                label="Kelas Kegunaan"
                min-width="240"
                :sortable="false">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                    <!-- <span style="word-break: break-word;">{{ scope.row.vehiclemodeltypeId ? `(${scope.row.vehiclemodeltypeId.modeltypeCode}) - ${scope.row.vehiclemodeltypeId.modeltypeName}` : '-' }}</span> -->
                    <span style="word-break: break-word;">{{ scope.row.vehicleModelTypeName ? `${scope.row.vehicleModelTypeCode ? `(${scope.row.vehicleModelTypeCode}) - `  : ''}${scope.row.vehicleModelTypeName}` : '-' }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Status Fleet Card"
                align="center">
                <el-table-column
                  prop="vehiclemodeltypeId"
                  width="140"
                  :label="syarikatMinyak"
                  :sortable="false"
                  :render-header="renderOilCompanyHeader"
                  v-for="(syarikatMinyak, syarikatMinyakIndex) in syarikatMinyakInvolved"
                  :key="syarikatMinyakIndex">
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;" v-if="buttonFull && scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak]">
                      <el-button type="secondary" v-if="!scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak].fleetcardInProgressFlag" @click="inProgressFleetCardDialog(scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak])">
                        <span style="line-height: 17px;">Fleet Card<br/>Dalam Proses</span>
                      </el-button>
                      <el-button type="primary" v-else-if="!scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak].fleetcardDeliveredFlag" @click="deliverFleetCardDialog(scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak])">
                        <span style="line-height: 17px;">Hantar<br/>Fleet Card</span>
                      </el-button>
                      <span style="line-height: 17px; text-align: center;" v-else>
                        Fleet Card<br/>Dihantar
                      </span>
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;" v-else>
                      <span style="text-align: center;">{{ scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak] ? scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak].fleetcardDeliveredFlag ? 'Telah Dihantar' : scope.row.physicalOilCompanyFleetCardVehicleJSON[syarikatMinyak].fleetcardInProgressFlag ? 'Dalam Proses' : 'Menunggu Maklumbalas' : '-' }}</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
    <el-dialog
      title="Fleet Card Dalam Proses"
      :visible.sync="userInProgressFleetCard"
      :close-on-click-modal="false"
      :before-close="resetForm">
      <span>Adakah anda pasti untuk Fleet Card sedang diproses?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Batal</el-button>
        <el-button v-loading="btnloading" type="primary" @click="inProgressFleetCard">Sahkan</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Hantar Fleet Card"
      :visible.sync="userDeliverFleetCard"
      :close-on-click-modal="false"
      :before-close="resetForm">
      <span>Adakah anda pasti Fleet Card telah dihantar?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Batal</el-button>
        <el-button v-loading="btnloading" type="primary" @click="deliverFleetCard">Sahkan</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Ulasan"
      :visible.sync="userReadMore"
      :before-close="resetForm">
      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center;">
        <span style="margin-bottom: 5px;">{{ currentCompanyName }}</span>
        <span style="font-weight: bold; font-size: 24px; color: #000;">{{ currentVehicleNumber }}</span>
        <span class="readMoreRemarks">{{ currentRemarks }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Tutup</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  activeTickFleetCardVehicles,
  personalExcelFleetCardVehicles
} from "@/api/mypetrolFleetCardVehicles";

import {
  oilcompanyInProgressPhysicalOilCompanyFleetCardVehicles,
  oilcompanyDeliveredPhysicalOilCompanyFleetCardVehicles
} from "@/api/mypetrolPhysicalOilCompanyFleetCardVehicles";

import bhplogo from '@/assets/bhplogo.png'
import caltexlogo from '@/assets/caltexlogo.png'
import petronlogo from '@/assets/petronlogo.png'
import petronaslogo from '@/assets/petronaslogo.png'
import shelllogo from '@/assets/shelllogo.svg'

import moment from 'moment'
export default {
  name: 'vehicle-new',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false,
      currentMonth: null,
      currRow: null,
      userReadMore: false,
      userInProgressFleetCard: false,
      userDeliverFleetCard: false,
      userInProgressFleetCard: false,
      userDeliverFleetCard: false,
      currentCompanyName: '',
      currentVehicleNumber: '',
      currentRemarks: '',
      syarikatMinyakInvolved: [
        // "petronas",
        // "petron",
        // "caltex",
        // "shell",
        // "bhp"
      ],
      syarikatMinyakList: [
        { value: 'petronas', label: 'Petronas' },
        { value: 'petron', label: 'Petron' },
        { value: 'caltex', label: 'Caltex' },
        { value: 'shell', label: 'Shell' },
        { value: 'bhp', label: 'BHP' },
      ],
      syarikatMinyakCounters: [
        {
          value: 'petronas',
          label: 'Petronas',
          transactions: 10000,
          color: '#00A19C',
          fontColor: '#ffffff',
          logo: petronaslogo,
          logoWidth: 30,
          logoHeight: 30,
          miniLogoWidth: 20,
          miniLogoHeight: 20,
          logoBackgroundColor: "#ffffff",
          active: false
        },
        {
          value: 'petron',
          label: 'Petron',
          transactions: 2000,
          color: '#408bc8',
          fontColor: '#ffffff',
          logo: petronlogo,
          logoWidth: 30,
          logoHeight: 30,
          miniLogoWidth: 20,
          miniLogoHeight: 20,
          logoBackgroundColor: "#ffffff",
          active: false
        },
        {
          value: 'caltex',
          label: 'Caltex',
          transactions: 30000,
          color: '#e62f46',
          fontColor: '#ffffff',
          logo: caltexlogo,
          logoWidth: 34,
          logoHeight: 34,
          miniLogoWidth: 22,
          miniLogoHeight: 22,
          logoBackgroundColor: "transparent",
          active: false
        },
        {
          value: 'shell',
          label: 'Shell',
          transactions: 5000,
          color: '#FFC800',
          fontColor: '#ffffff',
          logo: shelllogo,
          logoWidth: 40,
          logoHeight: 40,
          miniLogoWidth: 24,
          miniLogoHeight: 24,
          logoBackgroundColor: "transparent",
          active: false
        },
        {
          value: 'bhp',
          label: 'BHP',
          transactions: 300,
          color: '#f26522',
          fontColor: '#ffffff',
          logo: bhplogo,
          logoWidth: 40,
          logoHeight: 40,
          miniLogoWidth: 24,
          miniLogoHeight: 24,
          logoBackgroundColor: "transparent",
          active: false
        },
      ],
      vehicleLoaded: false
    }
  },
  methods: {
    renderOilCompanyHeader(h, { column }) {
      const syarikatMinyakLogo = this.syarikatMinyakCounters.find(item => item.value === column.label)
      if (!syarikatMinyakLogo) return null
      return h('div', {
        style: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center'
        }
      }, [
        h('div', {
          style: {
            display: 'flex',
            flexDirection: 'row',
            width: "36px",
            height: "36px",
            backgroundColor: syarikatMinyakLogo.color,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            marginRight: '8px'
          }
        }, [
          h('div', {
            style: {
              display: 'flex',
              flexDirection: 'row',
              width: "34px",
              height: "34px",
              backgroundColor: syarikatMinyakLogo.logoBackgroundColor,
              borderRadius: '50%',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }, [
            h('img', {
              attrs: {
                src: syarikatMinyakLogo.logo,
              },
              style: {
                width: `${syarikatMinyakLogo.miniLogoWidth}px`,
                height: `${syarikatMinyakLogo.miniLogoHeight}px`,
                objectFit: 'contain',
              }
            })
          ]),
        ]),
        h('span', syarikatMinyakLogo.label)
      ])
    },
    resetForm() {
      this.userReadMore = false
      this.userInProgressFleetCard = false
      this.userDeliverFleetCard = false
      this.currentCompanyName = ''
      this.currentVehicleNumber = ''
      this.currentRemarks = ''
      this.currRow = null
    },
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    },
    rowClick(row, column) {
      // if (column.label !== '#' && column.label !== 'Tindakan') {
      //   row.vehicleActiveTickedFlag = row.vehicleActiveTickedFlag === true ? false : true
      // }
    },
    async personalExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let resp = await personalExcelFleetCardVehicles(this.$store.state.app.branchSelected, this.registerForm.branchId)
        var link = document.createElement('a')
        link.href = URL.createObjectURL(new Blob([resp]))
        var fileName = `Senarai Kenderaan-${moment().unix()}.xlsx`
        link.download = fileName
        link.click()
      } catch (err) {
        console.log("download excel", err)
      }
      loading.close()
    },
    getVehicleStatusLabel(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const vehicleActiveTickedFlag = row.vehicleActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return "RAYUAN LULUS"
      }
      if (!vehicleValidBodyFlag) {
        return "JENIS BADAN TIDAK LAYAK"
      }
      if (!vehicleValidModelFlag) {
        return "KELAS KEGUNAAN TIDAK LAYAK"
      }
      if (vehicleRoadTaxPassedFlag) {
        return "TAMAT CUKAI JALAN"
      }
      return "KENDERAAN LAYAK"
    },
    getVehicleStatusValue(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const vehicleActiveTickedFlag = row.vehicleActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return true
      }
      if (!vehicleValidBodyFlag || !vehicleValidModelFlag || vehicleRoadTaxPassedFlag) {
        return false
      }
      return true
    },
    async navigateToWebPage(webpage) {
      this.$router.push(`/z/${this.$store.state.app.branchSelected}/mypetrol/${webpage}`)
    },
    async inProgressFleetCard() {
      const row = this.currRow
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        await oilcompanyInProgressPhysicalOilCompanyFleetCardVehicles(this.$store.state.app.branchSelected, row._id)
        this.$message({
          message: 'Status pengeluaran Fleet Card telah dikemaskini',
          type: 'success'
        })
        this.handleStatusChange()
      } catch (err) {
        console.log("err", err)
      }
      loading.close()
      this.resetForm()
    },
    async deliverFleetCard() {
      const row = this.currRow
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        await oilcompanyDeliveredPhysicalOilCompanyFleetCardVehicles(this.$store.state.app.branchSelected, row._id)
        this.$message({
          message: 'Status penghantaran Fleet Card telah dikemaskini',
          type: 'success'
        })
        this.handleStatusChange()
      } catch (err) {
        console.log("err", err)
      }
      loading.close()
      this.resetForm()
    },
    inProgressFleetCardDialog(row) {
      this.currRow = row
      this.userInProgressFleetCard = true
    },
    deliverFleetCardDialog(row) {
      this.currRow = row
      this.userDeliverFleetCard = true
    },
    readMoreDialog(row) {
      this.userReadMore = true
      if (this.registerForm) {
        this.currentCompanyName = this.registerForm.userGeneralName ? this.registerForm.userGeneralName : this.registerForm.userCompanyName
      }
      this.currentVehicleNumber = row.vehicleNumber
      this.currentRemarks = row.vehicleAppealRemarks
    },
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    vehicleArray: {
      type: Array
    },
    searchKenderaan: {
      type: String
    },
    handleStatusChange: {
      type: Function
    },
    saveAndNavigate: {
      type: Function
    },
    viewRayuan: {
      type: Function
    },
    profileVehicleType: {
      type: String
    },
    locked: {
      type: Boolean
    },
    buttonFull: {
      type: Boolean
    },
    registerForm: {
      type: Object
    }
  },
  filters: {
    formatProfileVehicleType(val) {
      switch (val) {
        case 'awambarangan': return 'AWAM & BARANGAN'
        case 'awam': return 'AWAM'
        case 'barangan': return 'BARANGAN'
        default: return '-'
      }
    },
    formatDateTime(val) {
      if (val !== undefined) {
        return moment.unix(Number(val)).format('DD/MM/YYYY HH:mm')
      }
      return ''
    },
    formatDate(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      }
      return '-'
    },
    formatNumber(val) {
      if (val !== null && val !== undefined) {
        return val.toLocaleString('en')
      }
      return '-'
    },
  },
  computed: {
    kenderaanKuotaAsa() {
      return Number(this.vehicleArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaBase) ? Number(item.vehicleQuotaBase) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    kenderaanKuotaSemasa() {
      return Number(this.vehicleArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaCurrent) ? Number(item.vehicleQuotaCurrent) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    currentMonthLabel() {
      switch (this.currentMonth) {
        case '01': return 'JANUARI'
        case '02': return 'FEBRUARI'
        case '03': return 'MAC'
        case '04': return 'APRIL'
        case '05': return 'MEI'
        case '06': return 'JUN'
        case '07': return 'JULAI'
        case '08': return 'OGOS'
        case '09': return 'SEPTEMBER'
        case '10': return 'OKTOBER'
        case '11': return 'NOVEMBER'
        case '12': return 'DISEMBER'
      }
    }
  },
  mounted() {
    this.currentMonth = moment().format('MM')
    this.syarikatMinyakInvolved = this.registerForm.profileOilCompanyList ? this.registerForm.profileOilCompanyList : []
    this.vehicleLoaded = true
  }
}
</script>


// WEBPACK FOOTER //
// src/views/mypetrol/components/VehicleFleetCard.vue